class VwServisprotokol2DTO {
    id: number = null;
    servisProtokol1Id?: number = null;
    yil?: number = null;
    protokolNo?: number = null;
    doktorId?: number = null;
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    doktorAd?: string = "";
    sitolojiOnek?: number = null;
}
export default VwServisprotokol2DTO;